import React, { Component } from 'react';
import MediaQuery from 'react-responsive';
import Headroom from 'react-headroom';
import constants from '../config';

import './UserNavbar.css';
import logo from './assets/logo.svg';
import logoDark from './assets/logo-gold.svg';
import AuthService from './AuthService';
import whiteBox from './assets/White_square.png';


const Auth = new AuthService();

class UserNavbar extends Component {
  constructor() {
    super();
    this.state = {
      query: '',
      profilePic: <img alt="profilePic" id="navbarProfile" src={whiteBox} />,
      socialNotifications: [],
      marketed: [],
      purchased: [],
      sales: [],
      replies: [],
      reviews: [],
      followers: [],
      observedFollowers: 0,
      isDark: document.documentElement.classList.contains('tw-dark'),
    };
    // this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.saleNotifications = this.saleNotifications.bind(this);
    this.toTop = this.toTop.bind(this);
    this.hideCats = this.hideCats.bind(this);
    this._darkObserver = null;
  }

  componentDidMount() {
    const user = Auth.getProfile(); // gets user object
    this.profile(user._id);
    this.saleNotifications();

    var nav = this;
    this._darkObserver = new MutationObserver(function() {
      var dark = document.documentElement.classList.contains('tw-dark');
      if (dark !== nav.state.isDark) nav.setState({ isDark: dark });
    });
    this._darkObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }

  componentWillUnmount() {
    if (this._darkObserver) this._darkObserver.disconnect();
  }
  componentWillReceiveProps(nextProps) {
    // console.log('navbarProps', nextProps);
    // uncommented this but it might be important...
    // this.profile(nextProps.user._id);
  }
  onSubmit() {
    this.setState({
      query: document.getElementById('search').value,
    }, () => {
      this.props.handleSearch(this.state.query);
    });
  }
  toTop() {
    window.scrollTo(0, 0);
  }
  profile(userId) {
    Auth.fetch(`${constants.DOMAIN}/api/v1/users/${userId}`, {
      mode: 'cors',
      method: 'GET',
    }).then(res => {
      console.log(res)
      this.setState({
        profilePic: <img alt="profilePic" id="navbarProfile" src={`${constants.DOMAIN}/` + res.profile.image} />,
        socialNotifications: res.notifications,
        replies: res.replies,
        followers: res.profile.followers,
        observedFollowers: res.profile.observedFollowers,
      }, () => {
        // console.log(this.state);
      });
    })
      .catch(err => {
        console.log(err);
      });
  }
  saleNotifications() {
    Auth.fetch(`${constants.DOMAIN}/api/v1/transactions/list`, {
      mode: 'cors',
      method: 'GET',
    })
      .then(res => {
        // console.log(res)
        this.setState({
          sales: res.sales,
          marketed: res.marketed,
          purchased: res.purchased,
          reviews: res.reviews,
        });
      })
      .catch(err => {
        console.log(err);
      });
  }
  hideCats() {
    const content = document.getElementsById('#navbar');
    content.style.display = 'none';
  }
  render() {
    // Following notification count how to fix??
    let followingCount = Number(this.state.followers.length) - Number(this.state.observedFollowers);
    if (followingCount < 0) {
      followingCount = 0;
    }
    let reviewCount = 0;
    this.state.reviews.forEach(review => { // new review
      if (review.observedReview === false) {
        reviewCount += 1;
      }
    });
    let purchaseCount = 0;
    this.state.purchased.forEach(purchase => {
      if (purchase.trackingNumber === '' && (purchase.paypalCheckoutStatus ==='COMPLETED' || purchase.stripeChargeId)) { // Sale was just made
        purchaseCount += 1;
      }
      if (purchase.trackingNumber !== '' && purchase.reviewed === false) { // order shipped but not reviewed
        purchaseCount += 1;
      }
    });
    let replyCount = 0;
    this.state.replies.forEach(reply => { // Number of replies
      replyCount += Number(reply.replyNotification);
    });
    let marketerCount = 0;
    this.state.marketed.forEach(sale => { // Sale made but seller didn't ship item
      if (sale.trackingNumber === '') {
        marketerCount += 1;
      }
      if (sale.trackingNumber !== '' && sale.marketerPaid === false) { // seller shipped item and marketer has not claimed their stake
        marketerCount += 1;
      }
    });
    let sellerCount = 0;
    this.state.sales.forEach(sale => {
      if (sale.trackingNumber === '' && (sale.paypalCheckoutStatus ==='COMPLETED' || sale.stripeChargeId)) { // seller must ship item sale made.
        sellerCount += 1;
      }
    });
    let socialCount = 0;
    this.state.socialNotifications.forEach((post) => { // posts have interactions
      socialCount += Number(post.commentNotifications);
      socialCount += Number(post.favoriteNotifications);
      socialCount += Number(post.shareNotifications);
    });

    let notificationCount = marketerCount + socialCount + sellerCount + replyCount + purchaseCount + reviewCount + followingCount;
    let bell = <i style={{ fontSize: '1.4em' }} className="fa fa-bell fa-stack-2x"><p id='notificationCountNav' >{notificationCount}</p></i>;
    // background of notification count
    // eslint-disable-next-line 
    let colorNotify = '#c9a84c';
    if (notificationCount === 0) {
      notificationCount = '';
      bell = <i style={{ fontSize: '1.2em' }} className="fa fa-bell-o" aria-hidden="true"></i>;
      colorNotify = 'transparent';
    }
    return (
      <div>
        <nav className="Navbar navbar navbar-inverse navbar-fixed-top">
          <div className="col-md-12 col-sm-12 col-xs-12 navbar-container">
            <div className="col-md-3 col-sm-4 col-xs-4 left-nav">
              <div className="col-md-6 col-sm-6 col-xs-6">
                <MediaQuery query="(max-device-width: 640px)">
                  <Headroom>
                    <span>
                      {/* eslint-disable-next-line */}
                      <a id="homeButton" className="btn notification-nav" onClick={this.props.handleHome}><img className="MetaNav" src={this.state.isDark ? logoDark : logo} alt="Logo" /><span id="navbarText">Home</span></a>
                    </span>
                  </Headroom>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 641px)">
                  {/* eslint-disable-next-line */}
                  <span><a id="homeButton" className="btn notification-nav" onClick={this.props.handleHome}><img className="MetaNav" src={this.state.isDark ? logoDark : logo} alt="Logo" /><span id="navbarText">Home</span></a></span>
                </MediaQuery>
              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                <MediaQuery query="(max-device-width: 640px)">
                  <Headroom>
                    {/* eslint-disable-next-line */}
                    <span><a id="notificationButton" className="btn notification-nav" onClick={this.props.handleNotifications}><span className="fa-stack fa-3x" id="nav-bell">{bell}</span> <span id="navbarText">Notifications</span></a></span>
                  </Headroom>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 641px)">
                  {/* eslint-disable-next-line */}
                  <span><a id="notificationButton" className="btn notification-nav" onClick={this.props.handleNotifications}><span className="fa-stack fa-3x" id="nav-bell">{bell}</span> <span id="navbarText">Notifications</span></a></span>
                </MediaQuery>
              </div>
            </div>
            <div className="col-md-6 col-sm-4 col-xs-4 search-nav">
              <form action="#" onSubmit={this.onSubmit} className="form-inline">
                <input id="search" className="form-control" type="search" placeholder="&#xF002;" style={{ fontFamily:'Arial, FontAwesome'}} aria-label="Search" />
              </form>
            </div>
            <div className="col-md-3 col-sm-4 col-xs-4 right-nav">
              <div className="col-md-6 col-sm-6 col-xs-6">
                <MediaQuery query="(max-device-width: 640px)">
                  <Headroom>
                    <span>
                      {/* eslint-disable-next-line */}
                      <a id="profileButton" className="btn notification-nav profileNav" onClick={this.props.handleSelfProfile}>{this.state.profilePic}</a>
                    </span>
                  </Headroom>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 641px)">
                  <span>
                    {/* eslint-disable-next-line */}
                    <a id="profileButton" className="btn notification-nav profileNav" onClick={this.props.handleSelfProfile}>{this.state.profilePic}</a>
                  </span>
                </MediaQuery>

              </div>
              <div className="col-md-6 col-sm-6 col-xs-6">
                {/* eslint-disable-next-line */}
                <span><a id="signUpTxt" className="btn" onClick={this.props.handlePost}><i className="fa fa-plus-circle" aria-hidden="true"></i><span style={{ marginLeft: '0px' }} id="navbarText">Post</span></a></span>

              </div>
            </div>
          </div>
        </nav>
      </div>
    );
  }
}

export default UserNavbar;
